<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 ">
  <loading v-if="loadingState" />
  <div class="container pt-2">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <div class="col-12">
        <h3 class="Regular  h0 widthFull"><b>Gestione Pratiche </b></h3>
      </div>
    </div>

    <div v-if="!presentPractices" class="row justify-content-center pb-5 pt-4 mt-5 vaillantCont">
      <h4 class="black center widthFull mt-4">Non hai preventivi accettati</h4>
      <router-link class="btn btn-primary btn-lg btnYellow mt-2" to="/offerte">Gestione Preventivi</router-link>
    </div>

    <!-- GAIUGE -->
    <div v-if="presentPractices" class="row justify-content-center pb-3 pt-3 align-items-end">
      <div  class="col-4 col-md-3 pb-0 pl-1 pr-1 pl-md-5 pr-md-5 d-none d-md-block">

        <VueSvgGauge v-if="counts.countCashClient " :start-angle="-90" :end-angle="90" :value="parseFloat(counts.countCashClient)" :separator-step="step" :min="0" :innerRadius="70" :separatorThickness="1" :max="maxTotCash"
          :gauge-color="[{ offset: 0, color: '#f39324'}, { offset: 100, color: '#00897e'}]" :scale-interval="step">

          <div class="gaugeText">
            <p class="widhtFull pt-5 mt-2"> € </p>
            <p class="widhtFull "> <b>{{counts.countCashClient | formatNumber}}</b> </p>
            <p class="widhtFull "> <small>Totale Fatt. quota Clienti</small></p>
          </div>
        </VueSvgGauge>

      </div>

      <div  class="col-5 col-md-3 pb-0 pr-0 pl-0">

        <VueSvgGauge v-if="counts.countCashInst " :start-angle="-90" :end-angle="90" :value="parseFloat(counts.countCashInst)" :separator-step="step" :min="0" :innerRadius="70" :separatorThickness="1" :max="maxTotCash"
          :gauge-color="[{ offset: 0, color: '#f39324'}, { offset: 100, color: '#00897e'}]" :scale-interval="step">

          <div class="gaugeText">
            <p class="widhtFull pt-5 mt-2"> € </p>
            <p class="widhtFull "> <b>{{counts.countCashInst | formatNumber}}</b> </p>
            <p class="widhtFull "> <small>Totale Fatt. quota Cessione</small></p>
          </div>
        </VueSvgGauge>

      </div>

      <div  class="col-4 col-md-3 center pl-1 pr-1 pl-md-5 pr-md-5  d-none d-md-block">
        <VueSvgGauge v-if="counts.countCashClient " :start-angle="-90" :end-angle="90" :value="parseFloat(counts.countCashClient) + parseFloat(counts.countCashInst)" :separator-step="step" :min="0" :innerRadius="70" :separatorThickness="1" :max="maxTotCash"
          :gauge-color="[{ offset: 0, color: '#f39324'}, { offset: 100, color: '#00897e'}]" :scale-interval="step">

          <div class="gaugeText">
            <p class="widhtFull pt-5 mt-2"> € </p>
            <p class="widhtFull "> <b>{{ parseFloat(counts.countCashClient) + parseFloat(counts.countCashInst) | formatNumber}}</b> </p>
            <p class="widhtFull "> <small>Totale Fatturato</small></p>
          </div>
        </VueSvgGauge>
      </div>

      <div class="col-6 col-md-3">
        <form v-on:submit.prevent="searchBy('text',filterVal)">
          <h5 class="text-center grey pb-0 mb-0">Ricerca Pratica</h5>
          <div class="input-group mb-0">
            <input type="text" v-model="filterVal" class="form-control seachMobButton" placeholder="Numero Pratica o Cognome...">
            <div class="input-group-append ">
              <button class="btn btn-outline-secondary btnYellow" v-on:click="searchBy('text',filterVal)" type="button"> <font-awesome-icon class="white" icon="search" size="sm" /> </button>
            </div>
          </div>
        </form>


        <button v-on:click="searchBy('status','10')" class="btn btn-danger widthFull mt-2" style="width: 68%;">
          <font-awesome-icon icon="trash-alt" class="white" size="sm" /> Eliminate <b class="ml-3"> {{ counts.hasRemovedPractics }} </b>
        </button>
        <button v-on:click="searchBy('','')" class="btn btn-secondary btnYellow mt-2" style="width: 28%;">
           Reset
        </button>

      </div>
    </div>

    <!-- END GAIUGE -->

    <!--
    <div v-if="presentPractices && 3==4" class="row mr-0 ml-0 justify-content-center pb-0 pt-0 align-items-end bgWhite mb-3">

      <div class="col-6 col-md-3 center Bold">
        <h5><b>€ {{ totAmountBefore10 | formatNumber }} </b></h5>
        <p>Credito in maturazione ( in verifica )</p>
      </div>

      <div class="col-6 col-md-3 center Bold">
        <h5><b>€ {{ totAmountAfter10 | formatNumber }} </b></h5>
        <p>Credito Cedibile al Cessionario*</p>
      </div>

      <div class="col-6 col-md-3 center Bold">
        <h5><b>€ {{ totUserReceived | formatNumber }} </b></h5>
        <p>Credito Ceduto al Cessionario*</p>
      </div>

      <div class="col-6 col-md-3 Bold">
        <p>* Il valore del credito cedibile e il valore del credito ceduto sono aggiornati agli ultimi 10 giorni</p>
      </div>

    </div>
    -->

    <div v-if="presentPractices" class="row justify-content-center align-items-end">

      <!--  -->
      <div class="col-4 col-md-2 text-left text-center text-md-left ">

        <div v-if="!lotOfData" class="buttonTextCont widthfull ">
          <h1 class="widthFull mt-0 center pb-0 mb-0"><b>{{counts.countPractices}}</b></h1>
          <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countPractices == 1">a</span> <span v-else>he</span> </p>-->
        </div>

        <a class="btn btn-info btn-green btn-sm  widthFull" v-on:click=" searchBy('','') ">
          <font-awesome-icon class="white" icon="clipboard-list" size="sm" /> <span class="d-none d-md-inline white"> Totale Pratiche</span>
        </a>

      </div>

      <div class="col-4 col-md-2 text-center text-md-left">

        <div v-if="!lotOfData" class="buttonTextCont widthfull lightRight">
          <h1 class="widthFull mt-0 center pb-0 mb-0"><b>{{counts.countErrorPractice}}</b></h1>
          <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countErrorPractice == 1">a</span> <span v-else>he</span> </p>-->
        </div>

        <a class="btn btn-danger btn-sm  widthFull" v-on:click="searchBy('errors','')">
          <font-awesome-icon icon="exclamation-triangle" size="sm" /><span class="d-none d-md-inline"> Con anomalie</span>
        </a>

      </div>


      <div class="col-4 col-4 col-md-2 text-center text-md-left  ">

        <div v-if="!lotOfData" class="buttonTextCont widthfull lightRight">
          <h1 class="widthFull mt-0 center pb-0 mb-0"><b>{{counts.countStep1Practice}}</b></h1>
          <!--  <p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep1Practice == 1">a</span> <span v-else>he</span> </p>-->
        </div>

        <a class="btn btn-danger btn-sm  widthFull" v-on:click="searchBy('status','1')">
          <font-awesome-icon icon="balance-scale" class="white" size="sm" /> <span class="d-none d-md-inline white"> Da completare</span>
        </a>

      </div>
      <div class="col-4 col-md-2 text-left  ">

        <div v-if="!lotOfData" class="buttonTextCont widthfull ">
          <h1 class="widthFull mt-0 center pb-0 mb-0"><b>{{counts.countStep2Practice}}</b></h1>
          <!--  <p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep2Practice == 1">a</span> <span v-else>he</span> </p>-->
        </div>

        <a class="btn btn-primary btn-sm btnYellow uppercase widthFull" v-on:click="searchBy('status','2')">
          <font-awesome-icon icon="balance-scale" class="white" size="sm" /> <span class="d-none d-md-inline white">In verifica</span>
        </a>

      </div>
      <div class="col-4 col-md-2 text-left">

        <div v-if="!lotOfData" class="buttonTextCont widthfull ">
          <h1 class="widthFull mt-0 center pb-0 mb-0"><b>{{counts.countStep3Practice}}</b></h1>
          <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep3Practice == 1">a</span> <span v-else>he</span> </p>-->
        </div>

        <a class="btn btn-primary btn-sm btnYellow widthFull" v-on:click="searchBy('status','3')">
          <font-awesome-icon icon="balance-scale" class="white" size="sm" /> <span class="d-none d-md-inline white"> In elaborazione </span>
        </a>

      </div>
      <div class="col-4 col-md-2 text-left  ">
        <div v-if="!lotOfData" class="buttonTextCont widthfull ">
          <h1 class="widthFull mt-0 center pb-0 mb-0"><b>{{counts.countStep4Practice}}</b></h1>
          <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep4Practice == 1">a</span> <span v-else>he</span> </p>-->
        </div>

        <a class="btn btn-primary btn-sm btn-green widthFull" v-on:click="searchBy('status','4')">
          <font-awesome-icon icon="balance-scale" size="sm" class="white" /> <span class="d-none d-md-inline white"> Elaborate </span>
        </a>
      </div>


      <!-- PAGINATION -->
      <div class="col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator">
          <pagination v-if="loaded" :options="{theme: 'bootstrap4', texts: { count: 'Visualizzazione da {from} a {to} di {count} Pratiche|{count} Pratiche|Una Pratica' }}" :records="practicesFiltredCount" v-model="page" :per-page="displayPerPage" @paginate="callback">
          </pagination>
      </div>
      <!-- END -->

    </div>

    <div  class="row justify-content-center pb-5 ">
      <div v-if="!showFilterText" class="col-md-12 col-lg-12">
        <badger-accordion key="sdfg345" class="pb-5 mt-4" :icons="{opened: '<span></span>', closed: '<span></span>'}">

          <badger-accordion-item v-for="(item,key) in practicesFiltred" class="" :key="item.code + '_' + countloop" v-if="item.status != 10">
            <template slot="header" class="center">

              <div class="row justify-content-center ">
                <div class="col-md-9 text-center text-md-left">
                  <h5 class="black"> Cessionario Finale:
                    <b v-if="item.flow == 'poste'"> Poste Italiane </b>
                    <b v-if="item.flow == 'cdp'"> Cassa Depositi e Prestiti </b>
                    <b v-if="item.flow == 'general'"> Flusso Base </b>
                    <b v-if="item.flow == 'agileenergy'"> Flusso Agile Energy </b>
                    <b v-if="item.flow == 'mbfacta'"> Flusso MBFACTA </b>
                    <b v-if="item.flow == 'mbfacta_recovery'"> Flusso Personalizzato </b>
                  </h5>
                  <h5 class="black csLineHeight2">
                     Pratica N. <b class="underline">{{ item.code }}</b>
                     del {{ moment(item.created_at).format('DD-MM-YYYY HH:mm') }} ( {{item.bonus}} ) <template v-if="item.payment_id != '0'"> <b v-if="item.flow != 'agileenergy'" class="green uppercase ml-4"> Pagata </b> </template>  <template v-else> <b v-if="item.flow != 'agileenergy'" class="red uppercase ml-4"> Non Pagata </b> </template>


                    <br/> Cliente: <b> {{ item.client_lastname }} {{item.client_name}}  </b>
                    <br/> Indirizzo dell'immobile: <b> {{item.building_address}} {{item.building_civic}} {{item.building_city}} ({{item.building_province}}) CAP {{item.building_zip}}  </b>

                    <template v-if="item.flow != 'agileenergy'">
                      <p class="pt-2"> <span > Totale Fatturato quota Cliente: <b class="black">€ {{ item.total_transfer_for_client | formatNumber }}</b> </span>
                        <br/> Totale Fatturato quota Cessione: <b class="black">€ {{ item.total_bonus_savings | formatNumber }}</b>
                      </p>

                    </template>
                    <template v-else>

                      <p class="pt-4 mb-1"> <span >

                          Altri Oneri per il Committente: <b class="black">€ {{ item.tot_extra_for_user | formatNumber }}</b>
                          <template v-if="item.payment_id != '0'"><b  class="green uppercase ml-4"> Pagato </b> </template>
                          <template v-else> <b  class="red uppercase ml-4"> Non Pagato </b> </template></span >
                    </p>
                    <p class="pt-1"> <span >
                          Installazione e posa in opera  <br/> dei beni per il Committente: <b class="black ml-3">€ {{ item.tot_bonifico_for_user | formatNumber }}</b>
                          <template v-if="item.payment_id2 != '0' && item.payment_id2 != '1'"><b  class="green uppercase ml-4"> Pagato </b> </template>
                          <template v-else> <b  class="red uppercase ml-4"> Non Pagato </b> </template>
                      </span >
                      </p>

                      <p class="pt-2"> <span >
                        <br/>Totale Fattura da installatore professionista in subappalto verso AGILE ENERGY
                        <br/>per il materiale e l'installazione, come indicati nel Preventivo: <b class="green">€ {{ item.totale_imponibile | formatNumber }}*</b> </span>
                       <br/><small>* Da fatturare <b>senza IVA </b> in quanto operazione soggetta al reverse charge art. 17, comma 6, lett. a-ter DPR 633/1972.

                       </small>

                     <br/>
                     <br/> Costo di gestione del Servizio del General Contractor AGILE ENERGY
                     <br/>a supporto della gestione di questa Pratica è pari a:
                     <b class="green">€ {{ item.price_agile | formatNumber }} + IVA (22%)</b>

                     <br/>che sarà fatturato da AGILE ENERGY verso l'installatore professionista in subappalto
                   </p>
                    </template>


                  </h5>

                  <template v-if="item.flow != 'agileenergy'">
                    <a class="btn btn-primary m-2 btnBlue btn-sm" :href="item.signed_order" target="_blank">
                      <font-awesome-icon icon="eye" size="sm" /> Visualizza Preventivo Firmato
                    </a>
                  </template>

                  <template v-if="item.flow == 'agileenergy'">
                    <a class="btn btn-primary m-2 btnBlue btn-sm" :href="item.lettera_di_affidamento_signed" target="_blank">
                      <font-awesome-icon icon="eye" size="sm" /> Visualizza Lettera di Affidamento
                    </a>
                    <br/>
                    <a class="btn btn-primary m-2 btnBlue btn-sm" :href="item.signed_order" target="_blank">
                      <font-awesome-icon icon="eye" size="sm" /> Visualizza Contratto per la fornitura e l’installazione
                    </a>


                  </template>

                  <!-- v-if=" ( item.flow == 'poste' && flow_poste_active) || ( item.flow == 'poste' && !flow_poste_active && item.payment_id != '0')  || ( item.flow == 'cdp' && flow_cdp_active) || ( item.flow == 'cdp' && !flow_cdp_active && item.payment_id != '0')" -->
                  <template v-if=" item.flow != 'agileenergy' ">
                    <router-link  :to="{ name: 'loadDocuments', params: {item: item} }" class="btn btn-primary btn-green m-2 btn-sm ">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Gestione Documenti
                    </router-link>
                  </template>

                  <template v-if="item.flow == 'agileenergy' && item.payment_id != 0">
                    <router-link  :to="{ name: 'loadDocuments', params: {item: item} }" class="btn btn-primary btn-green m-2 btn-sm ">
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Gestione Documenti
                    </router-link>
                  </template>

                  <template v-if="item.flow != 'agileenergy'">
                  <button type="button" v-if="item.status == 1 && item.payment_id == '0'" class="btn btn-danger m-2 btn-sm" v-on:click="removePractice(item.id,item.code,key)">
                    <font-awesome-icon icon="trash-alt" size="sm" /> Elimina
                  </button>
                  </template>

                  <img v-if="item.status == 1" class="img-fluid widthFull traficLight maxBomTr2 ml-md-5" src="../../assets/images/traficLight_red.png">
                  <img v-if="item.status == 2 || item.status == 3 || item.status == 4" class="img-fluid widthFull traficLight maxBomTr2 ml-md-5" src="../../assets/images/traficLight_yellow.png">
                  <img v-if="item.status == 5" class="img-fluid widthFull traficLight maxBomTr2 ml-md-5" src="../../assets/images/traficLight_green.png">

                </div>

                <div class="col-7 col-md-1 center pl-md-0 pr-md-0 pt-3 ">
                  <img v-if="item.enea_request == '1'" class="img-fluid widthFull mt-2" :class="{'bg-success': checkEneaComplate( item.aditional_enea_data) }" src="../../assets/images/enea.png">
                  <img v-if="item.to_get_cadastral_data == '1'" class="img-fluid widthFull mt-2" :class="{'bg-success': item.dcast_export == '10' }" src="../../assets/images/dcast.png">
                </div>

                <div  class="col-md-2 center pt-3">

                  <span v-if="item.status == 1 && item.flow != 'agileenergy'" class="inline-block center relative topCust2 d-none d-md-inline " style="position: initial!important;">
                    <img class="qrcodeImg qrcodeImg2" :src="item.qrcode">
                    <br /><small class="qrcodeText"><b>Carica documenti con</b></small>
                  </span>

                  <span v-if="item.status != 1 && item.ade_protocol_number " class="inline-block center relative topCust2 d-md-inline pt-4 pt-md-0 pb-0 " style="position: initial!important;">
                    <p class="pt-0 pt-md-2 pb-md-2 bgGreen white Regular"  ><small><b>Protocollo AdE nr. {{item.ade_protocol_number}}</b></small></p>
                  </span>

                </div>

                <!--
                <div class="col-md-1">
                  <a class="greenLinkAccordion2 Regular d-none d-md-block">Dettagli</a>
                </div>
                -->

                <div v-if="item.status == 1 && item.hasErrors == 'no'" class="col-11 col-md-11 mt-3 center requiredCont">

                   <!-- && flow_poste_active) || ( item.flow == 'poste' && !flow_poste_active && item.payment_id != '0' -->

                  <router-link v-if="(item.flow == 'poste' )" :to="{ name: 'loadDocuments', params: {item: item}}" >
                  <h5 class="black widthFull text-left">
                    <b class=" mr-4">Per procedere:</b>
                    <span> Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI </span>
                  </h5>
                  </router-link>
                  <!--<template v-else-if="item.flow == 'poste' && !flow_poste_active && item.payment_id == '0'" >
                    <a  class="btn btn-primary btnYellow m-2 btn-sm white "  disabled v-html="poste_not_active_text">  </a>
                  </template>-->

                  <!-- && flow_cdp_active) || ( item.flow == 'cdp' && !flow_cdp_active && item.payment_id != '0' -->
                  <router-link v-else-if="( item.flow == 'cdp' || item.flow == 'general' || item.flow == 'mbfacta' || item.flow == 'mbfacta_recovery'  )" :to="{ name: 'loadDocuments', params: {item: item}}" >
                  <h5 class="black widthFull text-left">
                    <b class=" mr-4">Per procedere:</b>
                    <span> Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI </span>
                  </h5>
                  </router-link>


                  <h5 v-else-if="(  item.flow == 'agileenergy' && item.payment_id == '0'  )" class="black widthFull text-left">
                    <b class=" mr-4">In attesa Pagamento:</b>
                    <span> Appena riceviamo pagamento dal cliente finale "degli Altri Oneri al committente" - abilitiamo set documentale </span>
                  </h5>


                  <router-link v-else-if="(  item.flow == 'agileenergy' && item.payment_id != '0'  )" :to="{ name: 'loadDocuments', params: {item: item}}" >
                  <h5 class="black widthFull text-left">
                    <b class=" mr-4">Per procedere:</b>
                    <span> Prepara e carica tutta la documentazione nella sezione GESTIONE DOCUMENTI </span>
                  </h5>
                  </router-link>
                  <!--
                  <template v-else-if="item.flow == 'cdp' && !flow_cdp_active && item.payment_id == '0'" >
                    <a  class="btn btn-primary btnYellow m-2 btn-sm white "  disabled v-html="cdp_not_active_text">  </a>
                  </template>
                -->

                </div>

                <!-- ENEA PDF + CPID -->
                <div v-if=" item.enea_request == '1' && checkEneaComplate( item.aditional_enea_data) " class="col-md-11  requiredCont">
                  <h5 class="Regular text-center h0 widthFull ">
                    <b >
                      <span class="green underline mr-3">
                      <a class="green" :href="item.enea_pdf" target="_blank"> Dichiarazione ENEA </a>
                     </span>

                     <span v-if="item.enea_email" class="green underline mr-3">
                     <a class="green" :href="item.enea_email" target="_blank"> Ricevuta ENEA E-mail  </a>
                    </span>

                     <small>Il codice CPID:</small> {{ item.enea_cpid }} </b>
                  </h5>

                </div>
                <!-- END DOCUMENTS REQUEST -->

                <!-- MODELLO AdE + Ricevuta AdE -->
                <div v-if="item.modelloAde || item.ricevutaAde " class="col-md-11  requiredCont">
                  <h5 class="Regular text-center h0 widthFull ">
                    <b >
                      <span v-if="item.modelloAde" class="green underline mr-3">
                      <a class="green" :href="item.modelloAde" target="_blank"> Modello AdE </a>
                     </span>

                     <span v-if="item.ricevutaAde" class="green underline mr-3">
                     <a class="green" :href="item.ricevutaAde" target="_blank"> Ricevuta AdE  </a>
                    </span>

                    <span v-if="item.duediligence" class="green underline mr-3">
                    <a class="green" :href="item.duediligence" target="_blank"> Due Diligence  </a>
                   </span>

                    </b>
                  </h5>

                </div>
                <!-- END DOCUMENTS REQUEST -->

                <!-- ENEA DOCUMENTS REQUEST -->
                <div v-if=" ( item.aditional_enea_data == null || item.aditional_enea_data == '' )  && item.enea_request == '1' && item.payment_id != '0' " class="col-md-11  requiredCont">
                  <h5 class="Regular text-center h0 widthFull ">
                    <b ><span class="red">Attenzione!</span> Per redigere ed inviare la Pratica ENEA necessitiamo di ulteriori informazioni </b>
                    <!-- <b v-else><span class="yellow">Attenzione!</span>  Per redigere ed inviare la pratica ENEA avremo bisogno di ulteriori informazioni che ti chiederemo alla conclusione del Set Documentale. </b>
                    -->
                    <router-link :to="{ name: 'complateEneaData', params: {item: item} }" class="btn btn-primary m-2 btn-sm">
                      Inserisci
                    </router-link>
                  </h5>

                </div>
                <!-- END DOCUMENTS REQUEST -->

                <div v-if="item.hasErrors == 'yes'" class="col-11 col-md-11 mt-3 center requiredCont">
                  <h5 class="black widthFull text-left">
                    <b class="widthFull mr-4"><span class="red"> Attenzione </span> abbiamo rilevato le seguenti anomalie:</b>
                  </h5>

                  <h5 class="red widthFull text-left pl-4">
                    {{ item.errors }}
                  </h5>

                </div>



                <div class="col-md-12 center pt-4">
                  <div class="card step-progress pt-3 ">
                    <div class="step-slider">
                      <div data-id="step1" v-on:click="$router.push({ name: 'loadDocuments', params: {item: item}})" class="step-slider-item " :class="{'active': item.status == 1, 'active passed': item.status != 1}">
                        <span class="stTitle">Step 1 <br /> <b>Carica Documentazione</b></span>
                      </div>
                      <div data-id="step2" class="step-slider-item " :class="{'notactive': item.status == 1,'active': item.status == 2, 'active passed': item.status != 1 && item.status != 2}">
                        <span class="stTitle">Step 2 <br /> <b>In verifica</b></span>
                      </div>
                      <div data-id="step3" class="step-slider-item notactive" :class="{'notactive': item.status == 2,'active': item.status == 3, 'active passed': item.status != 1 && item.status != 2 && item.status != 3}">
                        <span class="stTitle">Step 3 <br /> <b>In elaborazione</b> </span>
                      </div>
                      <div data-id="step4" class="step-slider-item notactive" :class="{'notactive': item.status == 3,'active': item.status == 4, 'active passed': item.status != 1 && item.status != 2 && item.status != 3 && item.status != 4}">
                        <span class="stTitle">Step 4 <br /> <b> Elaborata</b></span>
                      </div>
                    </div>
                    <div class="step-content">

                    </div>
                  </div>
                </div>

              </div>

            </template>
            <!--
            <template slot="content" class="bbaLightColor">
              <div class="row justify-content-center pb-2 pl-md-3 pr-md-3">

                <div class="col-md-9 text-left">
                  <h5 class="black"> Indirizzo dell'immobile
                    <b>{{item.building_address}} {{item.building_civic}} - {{item.building_zip}} {{item.building_city}} ({{item.building_province}}) </b>

                  </h5>
                </div>

                <div class="col-md-3 text-left">

                </div>


                <div class="col-md-3 text-left">
                  <h5 class="black pb-0 text-left widthFull"> Da Cliente: <b> € {{ parseFloat(item.total_transfer_for_client)  | formatNumber }}</b> </h5>
                </div>

                <div class="col-md-3 text-left">
                  <h5 class="black pb-0 text-left"> Da Cessione: <b> € {{ parseFloat(item.total_bonus_savings)  | formatNumber }}</b> </h5>
                </div>

                <div class="col-md-3 text-left">
                  <h5 class="black pb-0 text-left"> Totale: <b> € {{ parseFloat(item.total_transfer_for_client) + parseFloat(item.total_bonus_savings)  | formatNumber }}</b> </h5>
                </div>



              </div>

            </template>
          -->
          </badger-accordion-item>


        </badger-accordion>

        <div v-if="hasRemovedPractics">
        <!-- <badger-accordion class="pb-5 mt-4 " key="12312412512354134">

          <badger-accordion-item class="" :id="'id_closed'" v-if=" filter == '' ">
            <template slot="header" class="center">  -->
              <h5 v-if="hasRemovedPractics" class="text-left black Regular">Pratiche Eliminate</h5>
              <p v-if="hasRemovedPractics" class="text-left black Regular">Attenzione! I dati contenuti in questa schermata non includono le Pratiche eliminate. </p>
            <!-- </template>
            <template slot="content" class="bbaLightColor"> -->

              <badger-accordion class="pb-5 mt-4 greyBg">

                <badger-accordion-item v-for="(item,key) in practicesFiltred" :key="item.code + '12'" class="greyBg" v-if="item.status == 10">

                  <template slot="header" class="greyBg">

                    <div class="row justify-content-center ">
                      <div class="col-md-9 text-center text-md-left">
                        <h5 class="black">
                          Pratica N. <b class="underline">{{ item.code }}</b>
                          del {{ moment(item.created_at).format('DD-MM-YYYY HH:mm') }} ( {{item.bonus}} )
                          per <b> {{item.client_name}} {{ item.client_lastname }} </b>
                        </h5>
                        <a class="btn btn-primary m-2 btnBlue btn-sm" :href="item.signed_order" target="_blank">
                          <font-awesome-icon icon="eye" size="sm" /> visualizza Preventivo Firmato
                        </a>

                      </div>
                      <div class="col-md-3 center pt-3">


                      </div>
                      <!--
              <div class="col-md-1">
                <a class="greenLinkAccordion2 Regular d-none d-md-block">Dettagli</a>
              </div>
            -->

                    </div>

                  </template>
                  <template slot="content" class="greyBg">
                    <div class="row justify-content-center pb-2 pl-md-3 pr-md-3">

                      <div class="col-md-9 text-left">
                        <h5 class="black"> Indirizzo dell'immobile
                          <b>{{item.building_address}} {{item.building_civic}} - {{item.building_zip}} {{item.building_city}} ({{item.building_province}}) </b>

                        </h5>
                      </div>

                      <div class="col-md-3 text-left">
                        <h5 class="black pb-0"> Dati dell'intervento</h5>
                        Tipo: <b><span class="uppercase Regular">{{item.intervention_type}}</span></b>
                      </div>


                      <div class="col-md-3 text-left">
                        <h5 class="black pb-0 text-left widthFull"> Da Cliente: <b> € {{ parseFloat(item.total_transfer_for_client)  | formatNumber }}</b> </h5>
                      </div>

                      <div class="col-md-3 text-left">
                        <h5 class="black pb-0 text-left"> Da Cessione: <b> € {{ parseFloat(item.total_transfer_for_user)  | formatNumber }}</b> </h5>
                      </div>

                      <div class="col-md-3 text-left">
                        <h5 class="black pb-0 text-left"> Totale: <b> € {{ parseFloat(item.total_transfer_for_client) + parseFloat(item.total_transfer_for_user)  | formatNumber }}</b> </h5>
                      </div>

                      <div class="col-md-3 text-left">
                        <h5 class="black pb-0"> <b>Data:</b>
                          <span class="uppercase">{{moment(item.intervention_date).format('DD-MM-YYYY')}}</span>
                        </h5>
                      </div>

                    </div>

                  </template>
                </badger-accordion-item>


              </badger-accordion>


              <!--
            </template>
          </badger-accordion-item>
        </badger-accordion> -->

       </div>
      </div>


      <div v-else class="col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5">
        <h5 class="center">Nessun risultato  {{ ( filterVal != 1 && filterVal != 2 && filterVal != 3 && filterVal != 4 ) ? ' per ' + filterVal : '' }}</h5>
      </div>


      <!-- PAGINATION -->
      <div class="col-12 col-md-12 pr-md-5 pl-md-5 center mt-5 pt-4 paginator">
          <pagination v-if="loaded" :options="{theme: 'bootstrap4', texts: { count: 'Visualizzazione da {from} a {to} di {count} Pratiche|{count} Pratiche|Una Pratica' }}" :records="practicesFiltredCount" v-model="page" :per-page="displayPerPage" @paginate="callback">
          </pagination>
      </div>
      <!-- END -->


    </div>

  </div>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  BadgerAccordion,
  BadgerAccordionItem
} from 'vue-badger-accordion'

import {
  VueSvgGauge
} from 'vue-svg-gauge'

import Pagination from 'vue-pagination-2';

const moment = require('moment')

export default {
  name: 'Practics',
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge,
    Pagination,
  },
  data() {
    return {
      token: '',
      loadingState: false,
      lotOfData: false,
      loading: false,
      practices: {},
      countloop: 1,
      moment: require('moment'),
      presentPractices: true,
      countPractices: 0,
      countCashClient: 0,
      countCashInst: 0,
      practicesFiltred: {},
      filter: false,
      moment: require('moment'),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      // COUNTS
      // ERROR
      countErrorPractice: 0,
      totErrorCashClient: 0,
      totErrorCashInst: 0,
      // STEP 1
      countStep1Practice: 0,
      totStep1CashClient: 0,
      totStep1CashInst: 0,
      // STEP 2
      countStep2Practice: 0,
      totStep2CashClient: 0,
      totStep2CashInst: 0,
      // STEP 3
      countStep3Practice: 0,
      totStep3CashClient: 0,
      totStep3CashInst: 0,
      // STEP 4
      countStep4Practice: 0,
      totStep4CashClient: 0,
      totStep4CashInst: 0,

      totUserReceived: 0,
      totAmountBefore10: 0,
      totAmountAfter10: 0,

      hasRemovedPractics: false,

      // NEW PAGINATION
      length: 0,
      filter: '',
      filterVal: '',
      counts: {
        countCashClient: "0",
        countCashInst: "0",
        countErrorPractice: "0",
        countPractices: "0",
        countStep1Practice: "0",
        countStep2Practice: "0",
        countStep3Practice: "0",
        countStep4Practice: "0",
        sumTotal: "0",
        hasRemovedPractics: '0'
      },
      displayPerPage: 10,
      page: 1,
      loaded: false,
      loadedCount: false,
      filterType: false,
      practicesFiltredCount: 0,

      flow_cdp_active: process.env.FLOW_CDP_ACTIVE,
      cdp_not_active_text: process.env.FLOW_CDP_NOT_ACTIVE_TEXT,
      flow_poste_active: process.env.FLOW_POSTE_ACTIVE,
      poste_not_active_text: process.env.FLOW_POSTE_NOT_ACTIVE_TEXT,

    }
  },
  methods: {
    // NEW PAGINATION

    checkEneaComplate(val){
      if( val ){
      if ( val.includes('"status":"success"') ){
        return true
      }else{
        return false
      }
      }
      else{
        return false
      }

    },

    searchBy(type, filter){

      this.page = 1
      this.getPractices( type, filter )

      if( filter == '10' || filter == '9' ){
        this.hasRemovedPractics = true
      }else{
        this.hasRemovedPractics = false
      }

    },

    callback: function(page) {
      console.log( 'CHANGE PAGE => To: ' + page )
      this.page = page
      this.getPractices(this.filterType, this.filterVal)

    },

    async getPractices(type , filter) {
      console.log( 'SEARCH BY => ' + type + ' / ' +  filter)
      var _vue = this
      _vue.practicesFiltred = {}

      _vue.showFilterText = false

      if( type && type != '' ){
        this.filterType = type
      }else{
        this.filterType = false
      }

      if( filter && filter != '' ){
        this.filterVal = filter
      }else{
        this.filterVal = ''
      }

      this.loadingState = true
      var token = _vue.getProfile.userToken

      if (token) {
        await axios({
            url: process.env.ROOT_API + 'api/getPracticesPagination',
            method: 'POST',
            data: {
              type: 'practices',
              user_token: token,
              displayPerPage: this.displayPerPage,
              page: this.page,
              filterType: this.filterType,
              filter: this.filterVal
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            _vue.practices = resp.data.practices

            if ( _vue.practices.length == 0 ){
              _vue.showFilterText = true
            }

            _vue.practicesFiltred = _vue.practices
            _vue.practicesFiltredCount = parseInt(resp.data.total)

            _vue.loadingState = false
            _vue.loaded = true
          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.presentPractices = false,
            _vue.loadingState = false
            _vue.loaded = true
          })
      }
    },
    getPracticesCounts() {

      var _vue = this

      this.loadingState = true
      var token = _vue.getProfile.userToken

      if (token) {
         axios({
            url: process.env.ROOT_API + 'api/getPracticesCounts',
            method: 'POST',
            data: {
              type: 'practices',
              user_token: token
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            console.log( 'COUNT PRACTICES => ' + resp.data.counts )

            _vue.counts = resp.data.counts

            _vue.length = parseInt(_vue.counts.countPractices)

            _vue.totCash = parseFloat(_vue.counts.sumTotal)
            if (_vue.totCash < 10000) {
              _vue.maxTotCash = 10000
              _vue.step = 1000
            } else if (_vue.totCash < 100000) {
              _vue.maxTotCash = 100000
              _vue.step = 10000
            } else if (_vue.totCash < 1000000) {
              _vue.maxTotCash = 1000000
              _vue.step = 100000
            } else if (_vue.totCash < 10000000) {
              _vue.maxTotCash = 10000000
              _vue.step = 1000000
            }

            _vue.loadingState = false

            _vue.loadedCount = true

            _vue.getPractices()

          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.presentPractices = false,
              _vue.loadingState = false
          })
      }
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    },

    removePractice(id, code, key) {
      var id_order = id
      var _vue = this


      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: '<br/>Sei sicuro di voler eliminare Pratica N. ' + code + '?<br/><br/>',
        showCancelButton: true,
        confirmButtonText: `SI`,
        cancelButtonText: `NO`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        console.log(result)
        if (result.value) {

          axios({
              url: process.env.ROOT_API + 'api/changeOrderState',
              method: 'POST',
              data: {
                id: id,
                user_token: _vue.getProfile.userToken,
                status: 10
              },
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {

              _vue.getPractices()
              _vue.$swal('Pratica N. ' + code + ' <br/>è stato eliminata ', '', 'success')

            })
            .catch(resp => {
              _vue.$swal('Ops. Riprova piu tardi', '', 'error')
            })

        }
      })

    },
    async checkBonusValues() {

      var _vue = this
      this.loadingState = true
      await axios({
          url: process.env.ROOT_API + 'api/checkBonusValues',
          method: 'POST',
          data: {
            user_token: _vue.getProfile.userToken,
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.loadingState = false


        })
        .catch(resp => {
          this.loadingState = false
        })


    },

  },
  watch: {
    getProfile: function(val) {
      if (val) {
        console.log(val)
        this.getPracticesCounts()
        //this.getPractices()
      }
    },
    filter: function(val) {
      this.filterValues()
    },
  },

  mounted() {

    var x = {
      0: {
        "text": "Carta Identita non leggibile",
        "document": "4sg233"
      },
      1: {
        "text": "Codice Fiscale non leggibile",
        "document": "4sg233"
      }
    }

    x = JSON.stringify(x)
    console.log(x)


    if (this.getProfile) {
      this.getPracticesCounts()
      //this.getPractices()
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    })

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>


<style>
@media (min-width: 20px) and (max-width: 767px) {
  .seachMobButton {
    padding: 0 !important;
    height: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pratiche/index.vue